import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-items-dark px-[15px] py-[32px] xl:p-[60px]',
    container:
      'container flex flex-col items-center gap-[24px] xl:flex-row xl:justify-between',
    brandsSection: 'order-1 flex flex-col items-center gap-[4px] xl:order-0',
    mainBrandLogo: 'max-w-[274px] flex-none',
    brandBlock: 'flex justify-center lg:justify-start',
    brandsList: '',
    brandItem: '',
    contactWrapper: 'flex flex-row gap-[48px]',
    phoneBlock: '',
    phoneNumber:
      'text-l leading-[140%] font-medium text-white hover:opacity-80',
    email: 'text-l leading-[140%] font-medium text-white hover:opacity-80',
    copyrightText: 'text-text-secondary text-base leading-[140%] font-light',
    copyright: '',
    infoSection: 'flex flex-col gap-[16px]',
    social:
      'flex items-center gap-[8px] text-base leading-[140%] font-medium text-white',
    socialIcon: '[&>path]:fill-white'
  }
});
